import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  drawerPaper: {
    position: 'absolute',
    width: 360,
    display: 'flex',
    flexDirection: 'column',
  },
  drawerBackdrop: {
    position: 'absolute',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 3,
    py: 2,
    borderBottom: '1px solid',
    borderColor: 'gray.12',
    flexShrink: 0,
  },
  drawerContent: {
    flex: 1,
    overflowY: 'auto',
  },
  drawerFooter: {
    display: 'flex',
    gap: 1.5,
    px: 3,
    py: 2,
    borderTop: '1px solid',
    borderColor: 'gray.12',
    flexShrink: 0,
    justifyContent: 'flex-end',
  },
  sectionContent: { display: 'flex', flexDirection: 'column', gap: 1.5, px: 3, pb: 2 },
  presetPills: { display: 'flex', flexWrap: 'wrap', gap: 1 },
  orDivider: { display: 'flex', alignItems: 'center', gap: 1.5 },
  orLine: { flex: 1 },
}
